import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'
import brandLogo from '../images/Small Logo.png'
const Footer = (props) => {
  return (
    <div className="footer-container1">
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer">
(function(){
  // Back to top functionality
  const backToTopBtn = document.getElementById("backToTop")

  function handleScroll() {
    if (window.scrollY > 300) {
      backToTopBtn.style.opacity = "1"
      backToTopBtn.style.visibility = "visible"
    } else {
      backToTopBtn.style.opacity = "0"
      backToTopBtn.style.visibility = "hidden"
    }
  }

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  // Initialize back to top button
  backToTopBtn.style.opacity = "0"
  backToTopBtn.style.visibility = "hidden"
  backToTopBtn.style.transition = "all 0.3s ease"

  window.addEventListener("scroll", handleScroll)
  backToTopBtn.addEventListener("click", scrollToTop)

  // Smooth reveal animation on scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  // Observe footer sections for animation
  const footerSections = document.querySelectorAll(
    ".footer-brand, .footer-nav-section, .footer-contact"
  )
  footerSections.forEach((section) => {
    section.style.opacity = "0"
    section.style.transform = "translateY(20px)"
    section.style.transition = "all 0.6s ease"
    observer.observe(section)
  })

  // Stagger animation for contact items
  const contactItems = document.querySelectorAll(".footer-contact-item")
  contactItems.forEach((item, index) => {
    item.style.opacity = "0"
    item.style.transform = "translateX(-20px)"
    item.style.transition = \`all 0.5s ease \${index * 0.1}s\`

    setTimeout(() => {
      item.style.opacity = "1"
      item.style.transform = "translateX(0)"
    }, 1000 + index * 100)
  })

  // Social links hover effect enhancement
  const socialLinks = document.querySelectorAll(".footer-social-link")
  socialLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      socialLinks.forEach((otherLink) => {
        if (otherLink !== link) {
          otherLink.style.opacity = "0.6"
          otherLink.style.transform = "scale(0.95)"
        }
      })
    })

    link.addEventListener("mouseleave", () => {
      socialLinks.forEach((otherLink) => {
        otherLink.style.opacity = "1"
        otherLink.style.transform = "scale(1)"
      })
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <footer className="footer">
        <div className="footer-main">
          <div className="footer-container">
            <div className="footer-brand">
              <div className="footer-logo">
                <div className="footer-logo-icon">
                  <img src={brandLogo} alt="Nature Ready Logo" width="72" height="72" />
                </div>
                <h3 className="footer-brand-name">Nature Ready</h3>
              </div>
              <p className="footer-brand-description">
                {' '}
                Premium Indian exports bringing nature&apos;s finest to global
                markets with authentic sustainability and elegant craftsmanship.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="footer-social">
                <a href="https://www.linkedin.com/in/natureready-exports-llp-74762b398/">
                  <div aria-label="LinkedIn" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2a2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6M2 9h4v12H2z"></path>
                        <circle cx="4" cy="4" r="2"></circle>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="https://www.instagram.com/thenatureready/#">
                  <div aria-label="Instagram" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <rect
                          width="20"
                          height="20"
                          x="2"
                          y="2"
                          rx="5"
                          ry="5"
                        ></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8A4 4 0 0 1 16 11.37m1.5-4.87h.01"></path>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="https://www.facebook.com/share/1Eyz6sqSb6/">
                  <div aria-label="Facebook" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a href="https://medium.com/@thenatureready">
                  <div aria-label="Medium" className="footer-social-link">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 1043.63 592.71"
                      fill="currentColor"
                    >
                      <g>
                        <path d="M588.67 296.35c0 163.7-131.3 296.36-293.33 296.36S2 460.05 2 296.35 133.3 0 295.33 0s293.34 132.65 293.34 296.35zM1041.63 296.35c0 145.3-64.8 263.1-144.7 263.1s-144.6-117.8-144.6-263.1S816.03 33.3 896.93 33.3s144.7 117.8 144.7 263.05zM841.63 296.35c0 129.2-57.6 234.1-128.7 234.1s-128.7-104.9-128.7-234.1 57.6-234.1 128.7-234.1 128.7 104.9 128.7 234.1z"/>
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-nav">
              <div className="footer-nav-section">
                <h4 className="footer-nav-title">Explore</h4>
                <ul className="footer-nav-list">
                  <li>
                    <a href="/">
                      <div className="footer-nav-link">
                        <span>Homepage</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="/product-gallery">
                      <div className="footer-nav-link">
                        <span>
                          {' '}
                          Product Gallery
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="/inquiry-custom-order">
                      <div className="footer-nav-link">
                        <span>
                          {' '}
                          Inquiry &amp; Custom Order
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="/about-us">
                      <div className="footer-nav-link">
                        <span>About Us</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-nav-section">
                <h4 className="footer-nav-title">Products</h4>
                <ul className="footer-nav-list">
                  <li>
                    <div className="footer-nav-link">
                      <span>Malyar Grade C Raisins</span>
                    </div>
                  </li>
                  <li>
                    <div className="footer-nav-link">
                      <span>Malyar AA Raisins</span>
                    </div>
                  </li>
                  <li>
                    <div className="footer-nav-link">
                      <span>Golden Round Raisins</span>
                    </div>
                  </li>
                  <li>
                    <div className="footer-nav-link">
                      <span>Turmeric Powder</span>
                    </div>
                  </li>
                  <li>
                    <div className="footer-nav-link">
                      <span>Turmeric Extract</span>
                    </div>
                  </li>
                  <li>
                    <div className="footer-nav-link">
                      <span>Moringa Leaf Powder</span>
                    </div>
                  </li>
                </ul>
              </div>

              
            <div className="footer-contact">
              <h4 className="footer-contact-title">Get in Touch</h4>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <div className="footer-contact-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </g>
                    </svg>
                  </div>
                  <div className="footer-contact-details">
                    <span className="footer-contact-text">
                      <span>
                        {' '}
                        NatureReady Exim LLP,
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>
                        {' '}
                        Sangli, Maharashtra, India
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                    </span>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-contact-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                      ></path>
                    </svg>
                  </div>
                  <div className="footer-contact-details">
                    <span className="footer-contact-text">+91-9766422422</span><br />
                    <span className="footer-contact-text">+91-9284844953</span>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-contact-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                      </g>
                    </svg>
                  </div>
                  <div className="footer-contact-details">
                    <span className="footer-contact-text">
                      contact@thenatureready.com
                    </span><br />
                    <span className="footer-contact-text">
                      thenatureready@gmail.com
                    </span>
                  </div>
                </div>
              </div>
                <a href="/inquiry-custom-order" className="footer-cta btn btn-primary">
                  Request Inquiry
                </a>
            </div>
          </div>
        </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-container">
            <div className="footer-bottom-content">
              <div className="footer-legal">
                <span className="footer-copyright">
                  {' '}
                  © 2025 NatureReady Exim LLP. All rights reserved.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                
              </div>
              <button
                id="backToTop"
                aria-label="Back to top"
                className="footer-back-to-top"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m5 12l7-7l7 7m-7 7V5"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className="footer-decoration">
          <div className="footer-pattern"></div>
          <div className="footer-gradient-overlay"></div>
        </div>
      </footer>
    </div>
  )
}

export default Footer
